import { getFullFieldPath } from '../../utils';

import { CONTRACT_OF_SERVICE_TAB_KEY } from './constants';

export const getFullCOSPath = (fieldId) => getFullFieldPath(CONTRACT_OF_SERVICE_TAB_KEY, fieldId);
